import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import axios from 'axios';

import EstadisticasPanel from '../estadisticas/EstadisticasPanel';
import Logout from '../Logout';
import Administracion from './Administracion';
import AutoexcluidosPanel from './AutoexcluidosPanel';
import PanelUsuarios from './admin/PanelUsuarios';
import PanelRoles from './admin/PanelRoles';
import PanelNotificaciones from './admin/PanelNotificaciones';
import PanelAuditLog from './admin/PanelAuditLog';

import logoImg from '../nav/logo.jpg';
import './Dashboard.css';

const BASE_URL = 'https://us-central1-inprojuy-f1173.cloudfunctions.net/app';

const MENU = [
  {
    section: 'Administración',
    roles: ['admin'],
    children: [
      { key: 'otraOpcion',   icon: 'pi pi-th-large',  label: 'Panel general' },
      { key: 'estadisticas', icon: 'pi pi-chart-bar', label: 'Estadísticas' },
    ],
  },
  {
    key: 'auto',
    icon: 'pi pi-ban',
    label: 'Autoexcluidos',
    roles: ['admin', 'adminauto', 'agente'],
  },
  {
    section: 'Usuarios y Roles',
    roles: ['admin'],
    children: [
      { key: 'usuarios',       icon: 'pi pi-user',    label: 'Usuarios' },
      { key: 'roles',          icon: 'pi pi-shield',  label: 'Roles y Permisos' },
      { key: 'notificaciones', icon: 'pi pi-bell',    label: 'Notificaciones' },
      { key: 'auditlog',       icon: 'pi pi-history', label: 'Historial de cambios' },
    ],
  },
  { key: 'perfilUsuario', icon: 'pi pi-user-edit', label: 'Mi perfil', roles: ['*'] },
  { key: 'salir',         icon: 'pi pi-sign-out',  label: 'Salir',     roles: ['*'], danger: true },
];

function hasAccess(item, role) {
  if (!item.roles) return true;
  if (item.roles.includes('*')) return true;
  if (!role) return false;
  return item.roles.includes(role);
}

export default function Dashboard() {
  const auth = useAuth();
  const [selected, setSelected]      = useState('perfilUsuario');
  const [userRole, setUserRole]       = useState(null);
  const [collapsed, setCollapsed]     = useState(false);
  const [mobileOpen, setMobileOpen]   = useState(false);
  const [openSection, setOpenSection] = useState(null);

  useEffect(() => {
    if (!auth.id) return;
    axios.get(`${BASE_URL}/users/${auth.id}/role`)
      .then((res) => setUserRole(res.data.role))
      .catch(() => setUserRole('user'));
  }, [auth.id]);

  function goTo(key) {
    if (key === 'salir') { auth.logout(); return; }
    setSelected(key);
    setMobileOpen(false);
  }

  function toggleSection(label) {
    setOpenSection((prev) => (prev === label ? null : label));
  }

  const visibleMenu = MENU.filter((item) => hasAccess(item, userRole));

  return (
    <div className="db-wrapper">
      {/* Overlay mobile */}
      <div
        className={`db-overlay ${mobileOpen ? 'visible' : ''}`}
        onClick={() => setMobileOpen(false)}
      />

      {/* ── SIDEBAR ── */}
      <aside className={`db-sidebar ${collapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''}`}>

        <div className="db-brand">
          <img src={logoImg} alt="INPROJUY" />
          <span className="db-brand-name">INPROJUY</span>
        </div>

        <nav className="db-nav">
          {visibleMenu.map((item, idx) => {
            if (item.section) {
              const isOpen = openSection === item.section;
              const maxH   = isOpen ? item.children.length * 44 : 0;
              return (
                <div key={idx}>
                  <div
                    className={`db-nav-item ${isOpen ? 'open' : ''}`}
                    onClick={() => toggleSection(item.section)}
                  >
                    <i className="pi pi-folder item-icon" />
                    <span className="item-label">{item.section}</span>
                    <i className="pi pi-chevron-down chevron" />
                  </div>
                  <div className="db-subnav" style={{ maxHeight: maxH + 'px' }}>
                    {item.children.map((child) => (
                      <div
                        key={child.key}
                        className={`db-subnav-item ${selected === child.key ? 'active' : ''}`}
                        onClick={() => goTo(child.key)}
                      >
                        <i className={`${child.icon} item-icon`} />
                        <span>{child.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              );
            }

            return (
              <div
                key={item.key}
                className={`db-nav-item ${selected === item.key ? 'active' : ''}`}
                style={item.danger ? { color: '#e53e3e', marginTop: 4 } : {}}
                onClick={() => goTo(item.key)}
              >
                <i
                  className={`${item.icon} item-icon`}
                  style={item.danger ? { color: '#e53e3e' } : {}}
                />
                <span className="item-label">{item.label}</span>
              </div>
            );
          })}
        </nav>

        <div className="db-collapse-btn" onClick={() => setCollapsed((c) => !c)}>
          <i className="pi pi-chevron-left collapse-icon" />
          <span>Colapsar</span>
        </div>
      </aside>

      {/* ── MAIN ── */}
      <main className="db-main">
        {/* Topbar solo en mobile */}
        <div className="db-topbar">
          <button className="db-hamburger" onClick={() => setMobileOpen(true)}>
            <i className="pi pi-bars" />
          </button>
          <span className="db-topbar-brand">INPROJUY</span>
        </div>

        <div className="db-content">
          {selected === 'perfilUsuario'    && <Logout />}
          {selected === 'otraOpcion'       && <Administracion />}
          {selected === 'estadisticas'     && <EstadisticasPanel />}
          {selected === 'auto'             && <AutoexcluidosPanel />}
          {selected === 'usuarios'         && <PanelUsuarios />}
          {selected === 'roles'            && <PanelRoles />}
          {selected === 'notificaciones'   && <PanelNotificaciones />}
          {selected === 'auditlog'         && <PanelAuditLog />}
        </div>
      </main>
    </div>
  );
}
